import { ExternalLinkIcon } from '@heroicons/react/outline'
import { Box, Link, Title } from 'components'
import { SectionContainer } from 'components/SectionContainer'
import { Colors } from 'constants/colors'
import { getSpacing } from 'utils'
import { VaultTableDesktop } from './VaultTableDesktop'

export const VaultsListDesktop = () => {
  return (
    <SectionContainer marginTop={getSpacing('m')} padding={0}>
      <Box marginTop={getSpacing('m')} marginLeft={getSpacing('m')}>
        <Title tag="h2" size="m">
          Borrow vaults
        </Title>
      </Box>
      <Box marginTop={getSpacing('m')}>
        <VaultTableDesktop />
      </Box>
      <Box
        marginBottom={getSpacing('m')}
        marginTop={getSpacing('m')}
        width="100%"
        alignItems="flex-end"
      >
        <Box marginRight={getSpacing('m')} flexDirection="row">
          <Link
            externalURL="https://wiki.arcx.money/application/borrowing/vault-design-and-credit-limits"
            color="TEXT_DARK"
            size="xs"
            weight="regular"
          >
            <Box flexDirection="row" alignItems="center">
              About our vault design&nbsp;
              <ExternalLinkIcon color={Colors.TEXT_DARK} width="16px" />
            </Box>
          </Link>
        </Box>
      </Box>
    </SectionContainer>
  )
}
